<!-- 考勤规则-->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <el-container style="min-height:650px;">
            <el-main style="border:solid 1px #ebeef5;">
                <el-table :data="rulesList" :show-header="false" class="new-el-table">
                    <el-table-column prop="Sort" width="20px">
                        <template slot-scope="scope">
                            <span>{{ scope.row.Sort+"." }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="RuleName" width="160px" align="right">
                        <template slot-scope="scope">
                            <span>{{ scope.row.RuleName+"：" }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="RuleValue" label="" width="200px">
                        <template slot-scope="scope">
                            <div v-if="scope.row.Code=='autofirsttime'">
                                <el-select
                                    size="small"
                                    v-model="scope.row.RuleValue"
                                    style="height:32px;"
                                >
                                    <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    ></el-option>
                                </el-select>
                            </div>
                            <div
                                v-else-if="scope.row.Code=='noovertime'||scope.row.Code=='checkonce'||scope.row.Code=='isovertime'"
                            >
                                <el-checkbox
                                    v-model="scope.row.RuleValue"
                                    true-label="true"
                                    false-label="false"
                                    v-if="scope.row.Code=='checkonce'"
                                ></el-checkbox>
                                <el-checkbox
                                    v-model="scope.row.RuleValue"
                                    true-label="true"
                                    false-label="false"
                                    @change="checked=>noovertimeChange(checked, scope.row)"
                                    v-if="scope.row.Code=='noovertime'"
                                ></el-checkbox>
                                <el-checkbox
                                    v-model="scope.row.RuleValue"
                                    true-label="true"
                                    false-label="false"
                                    @change="checked=>isovertimeChange(checked, scope.row)"
                                    :disabled="isovertimeDisable"
                                    v-if="scope.row.Code=='isovertime'"
                                ></el-checkbox>
                            </div>
                            <div style="position:relative;" v-else>
                                <el-input
                                    v-model="scope.row.RuleValue"
                                    size="small"
                                    style="width:160px"
                                    v-if="scope.row.Code=='afterovertime'"
                                    :disabled="afterovertimeDisable"
                                ></el-input>
                                <el-input
                                    v-model="scope.row.RuleValue"
                                    size="small"
                                    style="width:160px"
                                    v-else
                                ></el-input>
                                <label class="timeTip">分钟</label>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="RuleDesc" label="">
                        <template slot-scope="scope">
                            <label style="color:#F60;">{{ scope.row.RuleDesc}}</label>
                        </template>
                    </el-table-column>
                </el-table>
                <el-footer>
                    <span style="color:red;">注意:考勤规则修改后只对修改当天之后的数据报表产生影响，如果要应用到以前的记录请执行重新统计操作。</span>
                    <el-button
                        type="primary"
                        size="mini"
                        @click="editAttendanceRule"
                        v-if="permission.edit"
                    >{{permission.edit}}</el-button>
                </el-footer>
            </el-main>
        </el-container>
    </div>
</template>

<script>
import breadcrumb from "@/components/common/breadcrumb";
export default {
  name: "attendanceRules",
  components: {
    breadcrumb
  },
  data() {
    return {
      entpId:this.$util.getLocalStorage("userMsg").EntpId,
      permission: this.$util.getPermission("AttendanceRules"),
      rulesList: [],
      options: [
        {
          value: "0",
          label: "关闭智能排班功能"
        },
        {
          value: "1",
          label: "按第一次打卡时间选择"
        },
        {
          value: "2",
          label: "按上下班打卡时间选择"
        }
      ],
      isovertimeDisable: false, //下班后记为加班是否可用
      afterovertimeDisable: false //下班多久开始计算是否可用
    };
  },
  created() {
    this.getAttendanceRuleList();
  },
  methods: {
    //不计算超额工时值改变
    noovertimeChange(sel, item) {
      if (sel == "true") {
        this.isovertimeDisable = true;
        this.afterovertimeDisable = true;
      } else {
        this.isovertimeDisable = false;
        let rulesList = this.rulesList;
        for (let i = 0; i < rulesList.length; i++) {
          if (
            rulesList[i].Code == "isovertime" &&
            rulesList[i].RuleValue == "true"
          ) {
            this.afterovertimeDisable = false;
            return;
          } else {
            this.afterovertimeDisable = true;
          }
        }
      }
    },
    //下班后记为加班值改变
    isovertimeChange(sel, item) {
      if (sel == "true") {
        this.afterovertimeDisable = false;
      } else {
        let rulesList = this.rulesList;
        this.afterovertimeDisable = true;
        for (let j = 0; j < rulesList.length; j++) {
          if (rulesList[j].Code == "afterovertime") {
            rulesList[j].RuleValue = 0;
            return;
          }
        }
      }
    },
    getAttendanceRuleList() {
      let that = this;
      this.$util
        .axiosGet({
          url: "/api/AttendanceSystem/GetAttendanceRuleList",
          data: { entpId: this.entpId }
        })
        .then(res => {
          if (res.data) {
            that.rulesList = res.data;
            for (let i = 0; i < res.data.length; i++) {
              if (
                res.data[i].Code == "noovertime" &&
                res.data[i].RuleValue == "true"
              ) {
                that.isovertimeDisable = true;
              }
              if (
                res.data[i].Code == "isovertime" &&
                res.data[i].RuleValue == "false"
              ) {
                that.afterovertimeDisable = true;
              }
            }
          }
        })
        .catch(err => {});
    },
    editAttendanceRule() {
      let rules = [];
      let rulesList = this.rulesList;
      let noovertimeVal = "";
      let isovertimeVal = "";
      for (const key in rulesList) {
        if (
          rulesList[key].Code == "checkinearly" ||
          rulesList[key].Code == "minworktime" ||
          rulesList[key].Code == "resttime" ||
          rulesList[key].Code == "afterovertime" ||
          rulesList[key].Code == "checkoutlast"
        ) {
          let numReg = /^[0-9]*$/;
          let numRe = new RegExp(numReg);
          if (!numRe.test(rulesList[key].RuleValue)) {
            this.$util.warningMsg("输入的分钟格式不正确");
            return false;
          }
        }

        if (rulesList[key].Code == "noovertime") {
          noovertimeVal = rulesList[key].RuleValue;
        }
        if (rulesList[key].Code == "isovertime") {
          if (noovertimeVal == "true") {
            rulesList[key].RuleValue = "false";
          }
          isovertimeVal = rulesList[key].RuleValue;
        }

        if (rulesList[key].Code == "afterovertime") {
          if (isovertimeVal == "false") {
            rulesList[key].RuleValue = "0";
          }
        }

        rules.push({
          RuleId: rulesList[key].RuleId,
          RuleValue: rulesList[key].RuleValue
        });
      }
      let _data = {
        EntpId: this.entpId,
        Rules: rules
      };
      this.$util
        .axiosPost({
          url: "/api/AttendanceSystem/EditAttendanceRule",
          data: _data
        })
        .then(res => {
          if (res.errcode == 0) {
            this.$util.successMsg("设置成功");
          }
        })
        .catch(err => {});
    }
  }
};
</script>    

<style lang="less" >
.timeTip {
  position: absolute;
  width: 29px;
  font-size: 12px;
  color: #336799;
  line-height: 32px;
}
.new-el-table {
  width: 100%;
}
.new-el-table tbody tr:hover > td {
  background-color: #ffffff !important;
}

/* 去掉表格单元格边框 */
.new-el-table th {
  border: none;
}
.new-el-table td,
.new-el-table th.is-leaf {
  border: none;
}
/* 表格最外边框 */
.new-el-table--border,
.new-el-table--group {
  border: none;
}
/* 头部边框 */
.new-el-table thead tr th.is-leaf {
  border: 1px solid #ebeef5;
  border-right: none;
}
.new-el-table thead tr th:nth-last-of-type(2) {
  border-right: 1px solid #ebeef5;
}
/* 表格最外层边框-底部边框 */
.new-el-table--border::after,
.new-el-table--group::after {
  width: 0;
}
.new-el-table::before {
  width: 0;
}
.new-el-table .new-el-table__fixed-right::before,
.new-el-table__fixed::before {
  width: 0;
}
/* 表格有滚动时表格头边框 */
.new-el-table--border th.gutter:last-of-type {
  border: 1px solid #ebeef5;
  border-left: none;
}
</style>